import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertTypeEnum } from 'src/app/shared/components/alert-inline/alert-inline.component';

export interface AlertDialogParameters {
  title?: string;
  closeButtonText?: string;
  messages: string[];
  type: AlertTypeEnum;
}

@Component({
  selector: 'tcs-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertDialogComponent implements OnInit {
  public title: string;
  public closeButtonText: string;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public params: AlertDialogParameters = {
      title: 'Alert!',
      messages: [''],
      closeButtonText: 'Close',
      type: AlertTypeEnum.Info,
    },
    public dialogRef: MatDialogRef<AlertDialogComponent>,
  ) {}

  public ngOnInit() {
    this.title = this.params.title != null ? this.params.title : 'Alert!';
    this.closeButtonText =
      this.params.closeButtonText != null ? this.params.closeButtonText : 'Close';
  }

  public close() {
    this.dialogRef.close();
  }

  get alertType() {
    if (this.params.type === AlertTypeEnum.Error) {
      return 'error';
    } else if (this.params.type === AlertTypeEnum.Warning) {
      return 'warning';
    } else {
      return 'info';
    }
  }
}
